export default "__VITE_ASSET__CTxsGlFB__"